export class CollectionSetAsThumbnailModel {
    public collectionIdList: Array<number>;

    constructor() {
        this.collectionIdList = new Array<number>();
    }
}
